<template>
  <div>
    <h1>Publisher Dashboard</h1>

  </div>
</template>

<script>
import * as api from "@/api";

export default {
  name: "PubDashboard",
};
</script>


// WEBPACK FOOTER //
// src/views/publisher/PubDashboard.vue